export const SimpleGrid = ({
  children,
  columns,
  gap,
}: {
  children: React.ReactNode;
  columns: number;
  gap: number;
}) => {
  return (
    <div
      className="grid"
      style={{
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: `${gap}rem`,
      }}
    >
      {children}
    </div>
  );
};
